import { message } from 'antd'
import { api } from '@/shared'
import { nominationActions } from '@/entity/nomination'

export const getDictValues = () => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getDictValuesAction())
			const res = await api.nomination.getDictValues()
			const filteredCode = [...new Set(res.map((i) => i.dictCode))]

			const requests = filteredCode?.map(async (i) => await api.nomination.getDictValue(i))

			Promise.all(requests).then((responses) => {
				let data = filteredCode?.reduce((obj, item, index) => Object.assign(obj, { [item]: responses[index] }), {})
				dispatch(nominationActions.getDictValuesActionDone(data))
			})
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getDictValuesActionFail())
		}
	}
}

export const getDictNomination = () => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getDictNominationAction())
			const res = await api.nomination.getDictNominations()
			dispatch(nominationActions.getDictNominationActionDone(res))
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getDictNominationActionFail())
		}
	}
}

export const getDictParams = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getDictParamsAction())
			const res = await api.nomination.getDictParams(data)
			let arr = res?.map((i, idx) => {
				let paramType = {
					Number: 'numValue',
					List: 'dictValue',
					Text: 'textValue',
					TextManyRows: 'textValue',
				}

				return {
					index: idx,
					localParamType: paramType[i.paramType] || null,
					...i,
				}
			})
			dispatch(nominationActions.getDictParamsActionDone(arr))
			onSuccess(arr)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getDictParamsActionFail())
		}
	}
}

export const setEmplSign = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setEmplSignAction())
			const res = await api.nomination.setEmplSign(data)
			dispatch(nominationActions.setEmplSignActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.setEmplSignActionFail())
		}
	}
}

export const setEmplXml = ({ data, onSuccess, onError }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setEmplXmlAction())
			const res = await api.nomination.setEmplXml(data)
			dispatch(nominationActions.setEmplXmlActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			onError()
			dispatch(nominationActions.setEmplXmlActionFail())
		}
	}
}

export const getEmplList = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getEmplListAction())
			const res = await api.nomination.getEmplList()
			let arr = res
				?.sort((a, b) => (a?.orderNum > b?.orderNum ? 1 : -1))
				?.map((i, idx) => ({
					index: idx,
					...i,
				}))
			dispatch(nominationActions.getEmplListActionDone(arr))
			onSuccess(arr)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getEmplListActionFail())
		}
	}
}

export const getMioCheckUser = () => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getMioCheckUserAction())
			const res = await api.nomination.getCheckUser()
			dispatch(nominationActions.getMioCheckUserActionDone(res))
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getMioCheckUserActionFail())
		}
	}
}

export const getMioById = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getMioByIdAction())
			const res = await api.nomination.getById(data)
			dispatch(nominationActions.getMioByIdActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getMioByIdActionFail())
		}
	}
}

export const getMioList = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getMioListAction())
			const res = await api.nomination.getList(data)
			dispatch(nominationActions.getMioListActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getMioListActionFail())
		}
	}
}

export const setMioRow = ({ data, payload, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setMioRowAction())
			const res = await api.nomination.setCheckRow({ data, payload })
			dispatch(nominationActions.setMioRowActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.setMioRowActionFail())
		}
	}
}

export const setMioXml = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setMioXmlAction())
			const res = await api.nomination.mioXml(data)
			dispatch(nominationActions.setMioXmlActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.setMioXmlActionFail())
		}
	}
}

export const setRejectMioXml = ({ data, payload, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setMioXmlAction())
			const res = await api.nomination.mioRejectXml({ data, payload })
			dispatch(nominationActions.setMioXmlActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.setMioXmlActionFail())
		}
	}
}

export const setMioSign = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setMioSignAction())
			const res = await api.nomination.mioSign(data)
			dispatch(nominationActions.setMioSignActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.setMioSignActionFail())
		}
	}
}

export const setMioReport = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setMioReportAction())
			const res = await api.nomination.setMioReport(data)
			dispatch(nominationActions.setMioReportActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.setMioReportActionFail())
		}
	}
}

export const getMioReport = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getMioReportAction())
			const res = await api.nomination.getMioReport(data)
			dispatch(nominationActions.getMioReportActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getMioReportActionFail())
		}
	}
}

export const getDtspMioList = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getDtspMioListAction())
			const res = await api.nomination.dtspMioList(data)
			dispatch(nominationActions.getDtspMioListActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getDtspMioListActionFail())
		}
	}
}

export const getDtspReportList = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getDtspReportListAction())
			const res = await api.nomination.dtspReportList(data)
			dispatch(nominationActions.getDtspReportListActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getDtspReportListActionFail())
		}
	}
}

export const setDtspReportSign = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setDtspReportSignAction())
			const res = await api.nomination.dtspReportSign(data)
			dispatch(nominationActions.setDtspReportSignActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.setDtspReportSignActionFail())
		}
	}
}

export const setDtspReportXml = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setDtspReportXmlAction())
			const res = await api.nomination.dtspReportXml(data)
			dispatch(nominationActions.setDtspReportXmlActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.setDtspReportXmlActionFail())
		}
	}
}

export const setDtspReqsList = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.setDtspReqsListAction())
			const res = await api.nomination.dtspReqsList(data)
			dispatch(nominationActions.setDtspReqsListActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.setDtspReqsListActionFail())
		}
	}
}

export const getDtspReqsOne = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getDtspReqsOneAction())
			const res = await api.nomination.dtspReqsOne(data)
			dispatch(nominationActions.getDtspReqsOneActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getDtspReqsOneActionFail())
		}
	}
}

export const getDtspReqsPage = ({ data, params, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(nominationActions.getDtspReqsPageAction())
			const res = await api.nomination.dtspReqsPage({ data, params })
			dispatch(nominationActions.getDtspReqsPageActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(nominationActions.getDtspReqsPageActionFail())
		}
	}
}
